// Module
var code = "<main-section data-title=404 class=\"dark full-height\"> <aside-info class=error> <p> The requested URL could not be found. </p> </aside-info> </main-section> ";
// Exports
export default code;